import React, { useState } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import Bo from '@shared/assets/HeaderImages/bo.svg';
import BoH from '@shared/assets/HeaderImages/boH.svg';
import College from '@shared/assets/HeaderImages/college.svg';
import CollegeH from '@shared/assets/HeaderImages/collegeH.svg';
import SignOut from '@shared/assets/HeaderImages/signOut.svg';

import { sxHeader } from './styles';

import GenericDropdown from '@shared/components/GenericDropdown';

const LogedUserButton = ({
  user,
  backofficeRedirect,
  pageConfiguration,
  collegeRedirect,
  loginHandler,
}) => {
  const [isHoveringBO, setIsHoveringBO] = useState(false);
  const [isHoveringCO, setIsHoveringCO] = useState(false);

  const menuItems = [
    {
      id: 'backoffice',
      icon: isHoveringBO ? BoH : Bo,
      fragments: [{ text: 'Back Office' }],
      action: backofficeRedirect,
      onMouseEnter: () => setIsHoveringBO(true),
      onMouseLeave: () => setIsHoveringBO(false),
    },
    ...(pageConfiguration.id === 1
      ? [
          {
            id: 'college',
            icon: isHoveringCO ? CollegeH : College,
            fragments: [{ text: 'College' }],
            action: collegeRedirect,
            onMouseEnter: () => setIsHoveringCO(true),
            onMouseLeave: () => setIsHoveringCO(false),
          },
        ]
      : []),
    {
      id: 'logout',
      icon: SignOut,
      fragments: [{ text: 'Cerrar Sesión' }],
      action: loginHandler,
    },
  ];

  const UserLabel = () => (
    <Grid container alignItems="center" spacing={1}>
      <Grid item>
        <AccountCircleSharpIcon sx={{ fontSize: 30, color: 'primary.main' }} />
      </Grid>
      <Grid item>
        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Typography sx={{ fontWeight: 'bold' }}>
            {user?.name && user?.lastname
              ? `${user?.name} ${user?.lastname}`
              : '-'}
          </Typography>
          <Typography sx={{ fontSize: '0.85rem', color: 'gray' }}>
            {user?.email ? user?.email : '-'}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );

  return (
    <Grid
      sx={sxHeader.userContainer}
      aria-controls="simple-menu"
      aria-haspopup="true"
      id="logedUserButton"
    >
      <GenericDropdown
        items={menuItems}
        selectedItem={null}
        onSelect={item => item.action()}
        buttonLabel={<UserLabel />}
        labelIcon={null}
        noBorder={true}
        hasArrow={false}
        mainColorInHover={true}
      />
    </Grid>
  );
};

export default LogedUserButton;
